export interface IBenefitCountryOptions {
  minimalOrderPriceThreshold: number;
  orderPriceActivationThreshold: number;
  isDeliveryBenefitEnabled: boolean;
}

export const BENEFITS_DEFAULT_SETTINGS: IBenefitCountryOptions = {
  minimalOrderPriceThreshold: 0,
  orderPriceActivationThreshold: 0,
  isDeliveryBenefitEnabled: false,
};
